import React from "react";

import Button from "@src/multiCustodian/components/MUI/Button/Button";
import Modal from "@src/sharedComponents/Modal/Modal";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./DeleteNoteModal.module.css";

interface DeleteNoteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting?: boolean;
  title: string;
  description: string;
  cancelText: string;
  confirmText: string;
}

const DeleteNoteModal = ({
  isOpen,
  onClose,
  onConfirm,
  isDeleting = false,
  title,
  description,
  cancelText,
  confirmText,
}: DeleteNoteModalProps): JSX.Element => {
  return (
    <Modal
      isOpen={isOpen}
      closeModal={onClose}
      modalStyle={{ padding: 0 }}
      showCloseButton
      className={styles.modal}
    >
      <div className={styles.container}>
        <div className={styles.content}>
          <Text variant="title2" color="text" className={styles.title}>
            {title}
          </Text>
          <Text
            variant="body"
            color="textSubtle"
            className={styles.description}
          >
            {description}
          </Text>
        </div>

        <div className={styles.actions}>
          <Button
            sx={{ flex: 1 }}
            style={{ width: "100%" }}
            onClick={onClose}
            size="medium"
            variant="outlined"
            buttonType="secondary"
            text={cancelText}
            disabled={isDeleting}
          />
          <Button
            sx={{ flex: 1 }}
            style={{ width: "100%" }}
            onClick={onConfirm}
            size="medium"
            variant="contained"
            buttonType="error"
            text={confirmText}
            disabled={isDeleting}
            isLoading={isDeleting}
          />
        </div>
      </div>
    </Modal>
  );
};

export default DeleteNoteModal;
